/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Back_To_ConversationsInputs */



/**
* | output |
* | --- |
* | "Back to conversations" |
*
* @param {Meeting_Back_To_ConversationsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_back_to_conversations = /** @type {((inputs?: Meeting_Back_To_ConversationsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Back_To_ConversationsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Terug naar gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour aux entretiens")
	return /** @type {LocalizedString} */ ("Back to conversations")
});